<template src='./phase-activities.html'></template>

<script>

import { EventBus } from '@/router/bus'

export default {
  components: {

  },
  props: ['selectedPhase', 'project'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      phaseStatusesManagedByAdmin: [3, 5, 6]
    }
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    openFormRevision (formId, formCode, formRevision) {
      const routeData = this.$router.resolve({ path: '/projects/' + this.project.code + '/phases/' + this.selectedPhase.id + '/forms/' + formCode + '/id/' + Number(formId) + '/revision/' + Number(formRevision) })
      window.open(routeData.href, '_blank')
    },
    displayOperation (selectedPhase, previousStatus, status, action) {
      if (previousStatus !== 12) {
        action = ''
      }
      return this.$t('projects.activities.' + selectedPhase + previousStatus + status + action)
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}
</style>
